<div class="math-field"  #mathField
     [class.has-shadow]="borderSettings?.hasShadow"
     [style.border-width.em]="borderSettings?.thickness"
     [style.border-color]="borderSettings?.color"
    ></div>
<!--<div [attr.hidden]="!isLocked ? true : undefined" class="math-field">{{this.getValue()}}</div>-->


